import { render, staticRenderFns } from "./ChooseStore.vue?vue&type=template&id=89f2bff8&scoped=true&"
import script from "./ChooseStore.vue?vue&type=script&lang=js&"
export * from "./ChooseStore.vue?vue&type=script&lang=js&"
import style0 from "./ChooseStore.vue?vue&type=style&index=0&id=89f2bff8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f2bff8",
  null
  
)

export default component.exports